import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import Link from 'next/link';

import Container from '../common/Container';
import CloudinaryImage from '../common/CloudinaryImage';

export default function Richtext({ richtext, color }) {
  return (
    <Container>
      {richtext?.map((data, key) => (
        <div
          // id={`${data?.title.replace(/\s/g, '')}`}
          key={data?.id}
          className={`${
            key % 2 === 0
              ? `bg-[linear-gradient(106.23deg,_#000815_73.94%,_#070162_102.87%)]`
              : `bg-[linear-gradient(251.39deg,_#000815_69.83%,_#3C035C_101.16%)]`
          } richtext lg:my-[75px] my-[35px] grid grid-cols-12 rounded-[20px] border-[#FFFFFF36] py-10 px-10 lg:gap-10 gap-5 text-left`}
          dir={key % 2 === 0 ? 'ltr' : 'rtl'}
        >
          <div className="lg:col-span-5 col-span-12">
            {data?.image?.data?.attributes?.url && (
              <CloudinaryImage
                backendImgUrl={data?.image?.data?.attributes?.url}
                alt={data?.image?.data?.attributes?.alternativeText}
                type="smallimg"
                className={`xl:w-[500px] w-full`}
                // className={
                //   'md:h-full w-full object-cover object-top xl:h-[600px] md:h-[550px] h-[350px] rounded-[20px]'
                // }
              />
            )}
          </div>
          <div className={`lg:col-span-7 col-span-12 text-[${color}]`}>
            <h6 className="lg:text-[55px] md:text-[40px] text-[26px] font-[600] leading-tight mb-3">
              {data?.title}
            </h6>
            {data?.descriptionEditor && (
              <ReactMarkdown
                rehypePlugins={[rehypeRaw]}
                className={`md:text-[20px] text-[14px] font-[400] leading-tight text-[#f9f9f9]`}
                source={data?.descriptionEditor}
              >
                {data?.descriptionEditor}
              </ReactMarkdown>
            )}
            <div
              className={`${(data?.Services?.length ?? 0) ? 'lg:mt-10 mt-5' : ''} ${key % 2 === 0 ? '' : 'justify-end'} flex flex-wrap lg:gap-5 gap-3`}
            >
              {data?.Services?.map(btn => (
                <span key={btn?.id} className="relative inline-block">
                  <Link href={`${btn?.link}`} className="gradientbtn">
                    {btn?.text}
                  </Link>
                  <div className="button-bg"></div>
                </span>
              ))}
            </div>
            <Link
              href={`${data?.btn_Link}`}
              className={`${data?.descriptionEditor && 'lg:mt-10 mt-5'} btncolorleftright inline-block border border-[#fff] lg:text-[20px] md:text-[16px] text-[14px] font-[500] py-3 px-5 rounded-[4px] relative overflow-hidden`}
            >
              <span className="relative z-[5] transition duration-300 ease-in-out">
                {data?.btn_Text}
              </span>
            </Link>
          </div>
        </div>
      ))}
    </Container>
  );
}
